import { render, staticRenderFns } from "./RateLimitDialog.vue?vue&type=template&id=404fa2f6&scoped=true"
import script from "./RateLimitDialog.vue?vue&type=script&lang=js"
export * from "./RateLimitDialog.vue?vue&type=script&lang=js"
import style0 from "./RateLimitDialog.vue?vue&type=style&index=0&id=404fa2f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404fa2f6",
  null
  
)

export default component.exports